import { ImageAndTextFieldsFragment } from "@src/generated/graphql";
import { highlightUnderscoreText } from "src/utils/utils";

type ContentOperationProps = {
  content: ImageAndTextFieldsFragment;
};

const ProductHero = ({ content }: ContentOperationProps) => {
  const {
    eyebrowText,
    title,
    imageDescriptionJson,
    buttonLink,
    additionalText,
    backgroundImage
  } = content;
  
  const imageDescriptionText =
    imageDescriptionJson?.json?.content?.[0]?.content?.[0]?.value ||
    additionalText ||
    "";

  return (
  <div className="product-banner">
    <div className="product-banner-block">
      <img
        src={backgroundImage?.url ?? ""}
        alt={backgroundImage?.title ?? "background-image-product-banner" }
        className="background-image"
      />
      <div className="product-gradient-overlay"></div>
      <div className="container-fluid custom-spacer-col position-relative gap-5">
        <div
          className="product-content-wrapper"
          style={{ minHeight: "500px" , marginTop:"200px" }}
        >
          <p className="product-description text-center">
            <strong>{eyebrowText?.split(" ")[0]}</strong>
            {eyebrowText?.split(" ").slice(1).join(" ")}
          </p>
          <h1
            className="product-title product-title-custom light"
            dangerouslySetInnerHTML={{
              __html: highlightUnderscoreText(title ?? ""),
            }}
          />

          <p className="product-description product-inner-description text-center light">
            {imageDescriptionText}
          </p>
          <a
            href={buttonLink?.buttonLink ?? ""}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-white"
          >
            <span>{buttonLink?.buttonText}</span>
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              className="btn-icon"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
  );
};

export default ProductHero;
